<script>
export default {
	name: 'IconSvgWmv',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_12_455)">
				<path
					d="M13.3995 4.10333C12.9348 4.10289 12.4893 3.92171 12.1607 3.59956C11.8321 3.2774 11.6473 2.84059 11.6468 2.385V0H3.81493C3.20843 -4.10554e-08 2.62677 0.236149 2.19783 0.65652C1.7689 1.07689 1.52781 1.64707 1.52759 2.24167V15.76C1.52826 16.3543 1.76955 16.9241 2.19844 17.3441C2.62732 17.7641 3.20873 18 3.81493 18H13.2159C13.5164 18.0001 13.8139 17.9422 14.0915 17.8295C14.3691 17.7169 14.6214 17.5517 14.8339 17.3435C15.0464 17.1352 15.2149 16.888 15.3299 16.6159C15.4449 16.3437 15.5041 16.0521 15.5041 15.7575V4.10333H13.3995Z"
					:fill="color" />
				<path
					d="M15.5041 4.10333H13.3995C12.9348 4.10289 12.4893 3.92171 12.1607 3.59956C11.8321 3.2774 11.6473 2.84059 11.6469 2.385V0L15.5041 4.10333Z"
					fill="#F35858" />
				<path
					d="M17.1624 14.2166H6.53403C5.78011 14.2166 5.16895 14.8157 5.16895 15.5549V18.6615C5.16895 19.4007 5.78011 19.9999 6.53403 19.9999H17.1624C17.9164 19.9999 18.5275 19.4007 18.5275 18.6615V15.5549C18.5275 14.8157 17.9164 14.2166 17.1624 14.2166Z"
					fill="#F35858" />
				<path
					d="M11.1103 15.854L10.4992 18.3598H9.73426L9.32628 16.6832L8.91405 18.3598H8.14909L7.53796 15.854H8.21028L8.53922 17.669L8.988 15.854H9.66796L10.1167 17.669L10.4491 15.854H11.1103Z"
					fill="#F3F3F6" />
				<path
					d="M15.1939 15.854L15.8194 17.7398L16.445 15.854H17.1063L16.2172 18.3598H15.4182L14.5326 15.854H15.1939Z"
					fill="#F3F3F6" />
				<path d="M7.23026 17.7542V18.36H6.59021V17.7542H7.23026Z" fill="#F3F3F6" />
				<path
					d="M14.2761 15.8723V18.3598H13.6581V16.8065L13.1082 18.3623H12.5735L12.0202 16.8032V18.3623H11.4022V15.8748H12.1579L12.8481 17.6073L13.5281 15.8748L14.2761 15.8723Z"
					fill="#F3F3F6" />
				<path
					d="M11.68 10.9925V7.01671C11.6798 6.99741 11.6778 6.97817 11.674 6.95921C11.6731 6.95355 11.6717 6.94797 11.6698 6.94255C11.6667 6.92952 11.6627 6.91671 11.6579 6.90421C11.6557 6.8985 11.6531 6.89294 11.6502 6.88755C11.645 6.87538 11.6388 6.86367 11.6315 6.85254L11.623 6.83921C11.6123 6.82412 11.6004 6.80991 11.5873 6.79671L11.5814 6.79171C11.5698 6.78103 11.5576 6.77101 11.5448 6.76171L11.5295 6.75255L11.4955 6.73421L11.4777 6.72671C11.4644 6.72167 11.4508 6.7175 11.4369 6.71421H11.4233C11.404 6.71021 11.3843 6.70825 11.3646 6.70838H5.63904C5.56035 6.71544 5.48717 6.75105 5.43386 6.80824C5.38056 6.86543 5.35097 6.94008 5.35088 7.01755C5.35088 7.02255 5.35088 7.02671 5.35088 7.03171V11.0067C5.34883 11.0579 5.3654 11.1081 5.39763 11.1484C5.42552 11.1946 5.46518 11.2328 5.51272 11.2594C5.56026 11.286 5.61404 11.3 5.66878 11.3H11.3638C11.4471 11.2996 11.5269 11.2672 11.586 11.2097C11.6451 11.1522 11.6789 11.0742 11.68 10.9925ZM5.69258 7.45671V6.85338H6.19322V7.45671H5.69258ZM6.53747 7.45671V6.85338H7.03814V7.45671H6.53747ZM7.38237 7.45671V6.85338H7.88303V7.45671H7.38237ZM8.22729 7.45671V6.85338H8.72793V7.45671H8.22729ZM9.07218 7.45671V6.85338H9.57282V7.45671H9.07218ZM9.91708 7.45671V6.85338H10.4177V7.45671H9.91708ZM10.762 7.45671V6.85338H11.2626V7.45671H10.762ZM5.57697 10.3825V7.62005H11.4615V10.3825H5.57697ZM5.69173 11.1484V10.545H6.19237V11.1484H5.69173ZM6.53662 11.1484V10.545H7.03729V11.1484H6.53662ZM7.38154 11.1484V10.545H7.88218V11.1484H7.38154ZM8.22643 11.1484V10.545H8.72708V11.1484H8.22643ZM9.07133 11.1484V10.545H9.57197V11.1484H9.07133ZM9.91622 11.1484V10.545H10.4169V11.1484H9.91622ZM10.7611 11.1484V10.545H11.2618V11.1484H10.7611Z"
					fill="#F35858" />
				<path
					d="M9.19639 8.79656L8.38293 8.33572C8.34085 8.3121 8.29319 8.29971 8.2447 8.29981C8.19621 8.2999 8.14858 8.31247 8.1066 8.33625C8.06461 8.36004 8.02973 8.39421 8.00543 8.43536C7.98113 8.4765 7.96827 8.52318 7.96814 8.57072V9.49239C7.96827 9.53993 7.98113 9.58661 8.00543 9.62775C8.02973 9.6689 8.06461 9.70307 8.1066 9.72686C8.14858 9.75065 8.19621 9.76321 8.2447 9.76331C8.29319 9.7634 8.34085 9.75101 8.38293 9.72739L9.19639 9.26656C9.23838 9.24268 9.27324 9.2084 9.29747 9.16716C9.3217 9.12591 9.33447 9.07915 9.33447 9.03156C9.33447 8.98396 9.3217 8.9372 9.29747 8.89596C9.27324 8.85471 9.23838 8.82043 9.19639 8.79656Z"
					fill="#F35858" />
			</g>
			<defs>
				<clipPath id="clip0_12_455">
					<rect width="20" height="20" fill="white" transform="translate(0.0275879)" />
				</clipPath>
			</defs>
		</svg>
	</div>
</template>

<style scoped>

</style>